import React from 'react';
export default ({ formattedCurrency }) => {
    return (React.createElement("header", { className: "headerWithLogoAndCart", "data-testid": "paypal-logo-with-cart" },
        React.createElement("p", { "data-testid": "paypal-logo", id: "paypalLogo", className: "payPalLogo" }),
        React.createElement("span", { className: "cartWrapper" },
            React.createElement("span", { className: "cart" },
                React.createElement("span", { className: "cartIcon" }),
                React.createElement("span", { className: "ltrDisplay" }, formattedCurrency)))));
};
